module.exports = __webpack_public_path__ + "static/media/info.40d6ddf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/info.png
// module id = 793
// module chunks = 0